import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);
// Production build → the live site; `npm start` → the local backend.
// Set REACT_APP_API_URL to override either.
export const API =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production' ? 'https://boomcreations.rw' : 'http://localhost:5000');

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.response.use(
  res => res,
  err => {
    const path = window.location.pathname;
    const onAdminPage = path.startsWith('/admin') && path !== '/admin/login';
    if (onAdminPage && (err.response?.status === 401 || err.response?.status === 403)) {
      window.location.href = '/admin/login';
    }
    return Promise.reject(err);
  }
);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/api/users/profile')
      .then(res => setUser(res.data))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const login = async (username, password) => {
    await api.post('/api/users/login', { username, password });
    setUser({ username });
  };

  const logout = async () => {
    await api.post('/api/users/logout');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

export async function apiFetch(path, options = {}) {
  try {
    const res = await api({
      url: path,
      method: options.method || 'GET',
      data: options.body ? JSON.parse(options.body) : undefined,
    });
    return res.data;
  } catch (err) {
    if (err.response?.status === 401 || err.response?.status === 403) return null;
    throw err;
  }
}
